import { render, staticRenderFns } from "./PrivateInvitationConfirm.vue?vue&type=template&id=744884e2&"
import script from "./PrivateInvitationConfirm.vue?vue&type=script&lang=ts&"
export * from "./PrivateInvitationConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports